import { handleActions } from 'redux-actions';
import { fetchPageSuccess } from '../actions/page';

const defaultState = {};

export default handleActions<any, any>(
  {
    [fetchPageSuccess.toString()]: (state, action) => ({
      ...state,
      ...action.payload,
    }),
  },
  defaultState
);
